import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Spacer, Text } from '@chakra-ui/react';
import { formatCurrency, formatPrice } from '@whitbread-eos/utils';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function TotalCostConfirmation(_ref) {
  var totalCostAmount = _ref.totalCostAmount,
    currency = _ref.currency,
    language = _ref.language,
    t = _ref.t;
  if (!totalCostAmount) return null;
  return _jsx(Box, _objectSpread(_objectSpread({
    "data-testid": 'confirmation-totalCost'
  }, totalCostWrapperStyle), {}, {
    children: _jsx(Box, {
      p: "lg",
      children: _jsxs(Flex, {
        w: "full",
        children: [_jsxs(Flex, {
          direction: "column",
          children: [_jsx(Text, {
            as: "b",
            "data-testid": "totalCost-label",
            children: "".concat(t('booking.confirmation.totalCost'), ":")
          }), _jsx(Text, {
            "data-testid": "totalCost-paymentMessage",
            children: t('booking.confirmation.paymentTaken')
          })]
        }), _jsx(Spacer, {}), _jsx(Text, _objectSpread(_objectSpread({
          "data-testid": 'totalCost-amount'
        }, totalCostAmountStyle), {}, {
          children: formatPrice(formatCurrency(currency), totalCostAmount.toFixed(2), language)
        }))]
      })
    })
  }));
}
var totalCostWrapperStyle = {
  mb: '2xl',
  backgroundColor: 'lightGrey5'
};
var totalCostAmountStyle = {
  as: 'b',
  fontSize: '3xxl',
  color: 'darkGrey1'
};